export default __webpack_public_path__ + "static/media/splash_page_video_5.b7e2cf2f.mp4";